import type { challenges as en } from '@/i18n/locales/en/challenges';
import type { Translation } from '@/i18n/types';

/** See `src/i18n/locales/en/challenges.ts`. */
export const challenges: Translation<typeof en> = {
  page: {
    title: 'Challenges',
    lead: 'Team-Challenges organisieren: Schritte, Schlaf, Workouts und mehr, mit optionaler Bestenliste.',
    noCompany: 'Wähle ein Unternehmen, um dessen Challenges zu sehen.',
    forbidden: 'Du hast keinen Zugriff auf die Challenges dieses Unternehmens.',
    empty: 'Noch keine Challenges — erstelle die erste.',
  },
  counts: {
    active: 'Aktive Challenges',
    draft: 'Entwürfe',
    completed: 'Abgeschlossen',
    totalParticipants: 'Teilnehmer insgesamt',
  },
  sections: {
    activePublished: 'Aktiv & veröffentlicht',
    draftsCompleted: 'Entwürfe & abgeschlossen',
  },
  card: {
    type: 'Typ',
    mode: 'Form',
    period: 'Zeitraum',
    goal: 'Ziel',
    reward: 'Belohnung',
    participants: 'Teilnehmer',
    engagement: 'Engagement',
    completion: 'Abschlussquote',
    leaderboardVisible: 'Bestenliste sichtbar',
    leaderboardHidden: 'Bestenliste verborgen',
  },
  mode: {
    individual: 'Einzeln',
    group: 'Team',
  },
  status: {
    draft: 'Entwurf',
    active: 'Aktiv',
    paused: 'Pausiert',
    completed: 'Abgeschlossen',
  },
  type: {
    steps: 'Schritte',
    sleep: 'Schlaf',
    workouts: 'Workouts',
    meditation: 'Meditation',
    custom: 'Individuell',
  },
  actions: {
    newChallenge: 'Neue Challenge',
    publish: 'Veröffentlichen',
    pause: 'Pausieren',
    resume: 'Fortsetzen',
    finish: 'Beenden',
    duplicate: 'Als Entwurf duplizieren',
    duplicateSuffix: 'Kopie',
    viewLeaderboard: 'Bestenliste ansehen',
    hideLeaderboard: 'Bestenliste ausblenden',
  },
  leaderboard: {
    title: 'Bestenliste',
    empty: 'Noch keine Teilnehmer.',
  },
  form: {
    title: 'Neue Challenge',
    submit: 'Challenge erstellen',
    cancel: 'Abbrechen',
    fields: {
      title: 'Titel',
      description: 'Beschreibung',
      type: 'Typ',
      mode: 'Form',
      startDate: 'Startdatum',
      endDate: 'Enddatum',
      goalValue: 'Zielwert',
      unit: 'Einheit',
      reward: 'Belohnung',
      leaderboardVisible: 'Bestenliste für Teilnehmer anzeigen',
    },
    errors: {
      required: 'Dieses Feld ist erforderlich.',
      endBeforeStart: 'Das Enddatum darf nicht vor dem Startdatum liegen.',
    },
  },
};
